import React from "react";
import {Image} from "react-bootstrap";
import maxiProfile from './maxi_profile.png';
import './ProfilePhoto.css';

const ProfilePhoto = () => {
    return (
        <div>
            <div>
                <Image src={maxiProfile} className="profile-photo" alt="Maxi Profile" rounded />
            </div>
        </div>
    );
}

export default ProfilePhoto;